import React from 'react';
import './Footer.scss';
import { useTranslation } from 'react-i18next';
import { FaInstagram } from "react-icons/fa";
import { MdPhone, MdAccessTime, MdLocationOn, MdEmail } from "react-icons/md";
import { Link } from 'react-router-dom';

const Footer = () => {
    const { t } = useTranslation();

    const footerMenu = [
        {
            'name' : t('footer.dentalServices'),
            'link' : '/leistungen'
        },
        {
            'name' : t('navbar.career'),
            'link' : '/karriere'
        },
        {
            'name' : t('footer.contactUs'),
            'link' : '/kontakt'
        }
    ];

    const footerContacts = [
        {
            'title': t('footer.phoneNumber'),
            'info': t('footer.phone'),
            'icon': 'phone'
        },
        {
            'title': 'E-Mail',
            'info': 'anmeldung@zahnarzt-st-toenis.de',
            'icon': 'email'
        },
        {
            'title': t('footer.openHour'),
            'info': t('footer.openingHours'),
            'icon': 'time'
        },
        {
            'title': t('footer.clinicAddress'),
            'info': t('footer.address'),
            'icon': 'location'
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <p>{t('footer.description')}</p>

                        <div className="social-logo">
                            <p>{t('footer.followUs')}</p>
                            <ul>
                                <li><a href="https://www.instagram.com/zap_boretskyi" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>{t('footer.quickLinks')}</p>
                            <ul>
                                {
                                    footerMenu.map((singleMenu, index) => <li key={index}><Link to={singleMenu.link}>{singleMenu.name}</Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>{t('footer.contactInfo')}</p>

                            {
                                footerContacts.map((footerContact, index) => {
                                    const getIcon = () => {
                                        switch(footerContact.icon) {
                                            case 'phone':
                                                return <MdPhone size={24} />;
                                            case 'email':
                                                return <MdEmail size={24} />;
                                            case 'time':
                                                return <MdAccessTime size={24} />;
                                            case 'location':
                                                return <MdLocationOn size={24} />;
                                            default:
                                                return null;
                                        }
                                    };
                                    
                                    return  <div key={index} className="contact-list">
                                                <div className="contact-icon">
                                                    {getIcon()}
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    {footerContact.icon === 'email' ? (
                                                        <h5><a href={`mailto:${footerContact.info}`}>{footerContact.info}</a></h5>
                                                    ) : (
                                                        <h5 style={{whiteSpace: 'pre-line'}}>{footerContact.info}</h5>
                                                    )}
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; {t('footer.copyright')}</p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/impressum'>Impressum</Link></li>
                            <li><Link to='/datenschutz'>Datenschutz</Link></li>
                            <li><Link to='/datenschutz-social-media'>Datenschutz Social Media</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;